(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxWorkstationDiagnostics(
    LOADER_CONSTANTS
  ) {
    return {
      restrict: 'EA',
      scope: {
        workstation: '=workstation',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/workstationProperties/workstationDiagnostics/workstationDiagnostics.template.html',
      link: function(scope) {

        scope.workstationDiagnostics = null;
        scope.workstationDiagnosticsRequestResult = null;
        scope.noWorkstationDiagnosticsDataMessage = "FAILED_DEVICE_NOT_FOUND";

        (function() {
          updateDiagnosticsSection();
        })();

        function updateDiagnosticsSection () {
          scope.workstationDiagnostics = null;
          scope.updateDiagnosticsSectionRunning = false;
          if (!scope.updateDiagnosticsSectionRunning) {
            scope.updateDiagnosticsSectionRunning = true;
            scope.workstationDiagnosticsRequestResult = LOADER_CONSTANTS.DATA_LOADING;
            scope.workstation.getDiagnostics().then(function(response) {
              scope.updateDiagnosticsSectionRunning = false;
              scope.workstationDiagnosticsRequestResult = LOADER_CONSTANTS.DATA_RECEIVED_NON_EMPTY;
              if (response && response.data) {
                scope.workstationDiagnostics = response.data;
              } else {
                throw "scope.updateDiagnosticsSection: response or response.data are missing";
              }
            }).catch(function(error){
              scope.updateDiagnosticsSectionRunning = false;
              scope.workstationDiagnosticsRequestResult = LOADER_CONSTANTS.DATA_RECEIVED_EMPTY;
            });
          }
        };

        scope.getAverageResponseTime = function() {
          if (scope.workstationDiagnostics && scope.workstationDiagnostics.pkgSent > 0) {
            return Math.floor(scope.workstationDiagnostics.msec / scope.workstationDiagnostics.pkgSent);
          } else {
            return 0;
          }
        };

        scope.getPrintedInTotal = function() {
          if (scope.workstationDiagnostics) {
            return scope.workstationDiagnostics.jobsDirectly + scope.workstationDiagnostics.jobsReleased;
          } else {
            return 0;
          }
        };

        scope.goToAuditPage = function() {
          $rootScope.auditEventsObject = angular.copy(scope.workstation);
          $location.path(URLS.HISTORY);
        };

        scope.getLogsFromClient = function() {
          scope.workstation.getLogsFromClient().then(function() {
            toastr.success($filter("translate")("LogUploaded"));
          }).catch(function(error){});
        };
      }
    };
  }

  pxWorkstationDiagnostics.$inject = ['LOADER_CONSTANTS'];

  angular
    .module('printix-admin')
    .directive('pxWorkstationDiagnostics', pxWorkstationDiagnostics);

})();
